<template>
  <section class="bg-white border border-slate-100 rounded-2xl shadow-sm p-6">
    <div class="flex items-center justify-between mb-5">
      <div class="flex items-center gap-2">
        <div class="w-7 h-7 bg-blue-50 rounded-lg flex items-center justify-center">
          <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
          </svg>
        </div>
        <h2 class="text-base font-bold text-slate-800">My Bookings</h2>
        <span v-if="bookings.length" class="text-xs font-semibold bg-slate-100 text-slate-600 px-2 py-0.5 rounded-full">
          {{ bookings.length }}
        </span>
      </div>

      <button
        @click="$emit('refresh')"
        class="flex items-center gap-1.5 text-xs font-medium text-slate-500 hover:text-blue-600 hover:bg-blue-50 px-2.5 py-1.5 rounded-lg transition-colors"
      >
        <svg class="w-3.5 h-3.5" :class="{ 'animate-spin': loading }" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
        </svg>
        Refresh
      </button>
    </div>

    <!-- Loading -->
    <div v-if="loading" class="flex items-center justify-center py-10">
      <svg class="w-5 h-5 animate-spin text-blue-500" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
      </svg>
    </div>

    <!-- Empty state -->
    <div v-else-if="bookings.length === 0" class="flex flex-col items-center justify-center py-10 text-center">
      <div class="w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center mb-3">
        <svg class="w-6 h-6 text-slate-400" fill="currentColor" viewBox="0 0 24 24">
          <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99z"/>
        </svg>
      </div>
      <p class="text-sm font-medium text-slate-600">No bookings yet</p>
      <p class="text-xs text-slate-400 mt-1">Your booked rides will appear here.</p>
    </div>

    <div v-else class="space-y-3">
      <BookingCard
        v-for="booking in bookings"
        :key="booking._id"
        :booking="booking"
      />
    </div>
  </section>
</template>

<script>
import BookingCard from "@/components/BookingCard.vue";

export default {
  name: "BookingList",
  components: { BookingCard },
  emits: ["refresh"],
  props: {
    bookings: { type: Array, required: true },
    loading:  { type: Boolean, default: false },
  },
};
</script>
